import { render, staticRenderFns } from "./IconPoiEntertainment.vue?vue&type=template&id=3b758464&"
import script from "./IconPoiEntertainment.vue?vue&type=script&lang=js&"
export * from "./IconPoiEntertainment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports